export const SET_PRODUCT_LIST_TOTAL = "SET_PRODUCT_LIST_TOTAL";
export const SET_PAGE_LIMIT = "SET_PAGE_LIMIT";
